/**
 * Modal Component
 * @author Rhys Lloyd
 */

//
// Utilities
import debug from "debug";
const MODULE_NAME = 'modal-components';
const log = debug(MODULE_NAME);

//
// Constants
const IS_MODAL_OPEN = 'is-modal-open';

//
// Dependencies
const Vue = window.Vue;
import { touchEvents } from '../../../services/browser-features';

import '@vendor/foundation/js/foundation.core';
import '@vendor/foundation/js/foundation.abide';

//
// Exports
export const ModalComponent = Vue.extend({
	props: {
		isOpen: {
			type: Boolean,
			default: false,
		},
	},

	watch: {
		isOpen: function (val) {
			if (val) {
				const foundation = new Foundation.Abide($(this.$el), {});
				log('Created Foundation Abide', foundation);
			} else {
				$(this.$el).foundation('destroy');
				log('Destroyed Foundation');
			}

			this.toggleModal(val);
		}
	},

	methods: {
		toggleModal (state) {
			// iOS bug with inputs inside fixed elements means we need to fix the body which results in the page
			// "scrolling" to the very top.
			// Workaround here saves the current scroll position to restore back to when we close the modal.
			if (state) {
				this.tempScollYPosition = window.scrollY;

			} else {
				this.$nextTick(() => {
					window.scrollTo(0, this.tempScollYPosition);
					delete this.tempScollYPosition;
				});
			}

			this.toggleBodyModalClass(state);
		},

		toggleBodyModalClass (state) {
			if (touchEvents) {
				log('touchevents');
				$('html').toggleClass(IS_MODAL_OPEN, state);
			}
		},

		closeModal () {
			this.isOpen = false;
		},
	},
});


// WEBPACK FOOTER //
// ./project/client/src/core/modules/modal/components/modal.js